import { memo } from 'react';

import { useLanguage } from 'assets/languages';
import { BrandDto } from 'api/repositories/brand/brand.types';
import { getCampaignCommissionOptions } from 'api/repositories/campaign/campaign.constants';
import { getCurrencySuffixByBrand } from 'helpers/currency';
import { Settings } from 'types/settings';
import { isJapanService } from 'constants/domains/domains';

export interface SelectCommissionProps {
  brand: Pick<BrandDto, 'currency' | 'destinationCountry'>;
  settings: Settings;
  selectedValue: number;
  onChange: (commission: number, commissionPrice: number, maxStep?: number) => void;
  isBig?: boolean;
}

const SelectCommission = ({
  brand: { currency, destinationCountry },
  settings,
  selectedValue,
  onChange,
  isBig = false,
}: SelectCommissionProps) => {
  const language = useLanguage();
  const languageTexts = { ...language.pages.campaigns };

  return (
    <>
      <ul
        className={`${
          isBig ? 'gap-[6px]' : 'gap-[5px]'
        } flex flex-row justify-between`}
      >
        {getCampaignCommissionOptions({
          currency,
          destinationCountry,
        }).map(({ commission, commissionPrice, maxStep, metaData }) => (
            <li
              key={`${isBig ? 'big-' : ''}commission-option-${commissionPrice}`}
              className={`${isBig ? 'h-[46px]' : 'h-[36px]'} ${
                selectedValue === commissionPrice ? 'border-[#000]' : 'border-[#E8E8E8]'
              } flex flex-1 items-center justify-center border text-[15px] cursor-pointer hover:opacity-70`}
              onClick={() => onChange(commission, commissionPrice, maxStep)}
            >
              {languageTexts._select_commission_label(commissionPrice, getCurrencySuffixByBrand(settings))}
            </li>
          ))}
      </ul>
      {!isJapanService() && (
        <ul
          className={`${
            isBig ? 'gap-[6px]' : 'gap-[5px]'
          } flex flex-row justify-between`}
        >
          {getCampaignCommissionOptions({
            currency,
            destinationCountry,
          }).map(({ commission, referenceUrl }, idx) => {
            return (
              <li
                key={`reference-url-${idx}-${commission}`}
                className="flex flex-1 items-center justify-center text-[11px] underline"
              >
                {referenceUrl ? (
                  <a href={referenceUrl} target="_blank" rel="noopener noreferrer">
                    {languageTexts.select_commission_reference_url_label}
                  </a>
                ) : null}
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
};

export default memo(SelectCommission);
